export const landingPageTemplates = {
  signupEnabled: 'signupEnabled',
};

